import { CUSTOM_EVENTS } from "constants/index";
import * as jwtDecode from "jwt-decode";
import store from "store";
import EventsService from "utils/eventsService";
import api from "./api";

export const TOKEN_KEY = "@grd-token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const getTokenDecoded = () => {
	let tokenDecoded;

	try {
		tokenDecoded = jwtDecode(getToken());
	} catch {
		return "";
	}

	return tokenDecoded;
};

const setUsuario = usuario => {
	store.dispatch({
		type: "SET_USUARIO",
		usuario
	});
};

export const clearUsuario = () => {
	store.dispatch({
		type: "CLEAR_USUARIO"
	});
};

export const login = token => {
	localStorage.setItem(TOKEN_KEY, token);
};

export const logout = async () => {
	localStorage.removeItem(TOKEN_KEY);

	clearUsuario();

	api.get("logout");
};

export const getUserApi = async callback => {
	try {
		const { data } = await api.get("user");
		if (data) {
			login(data.details.tokenValue);

			const usuario = await api.get("usuario");
			setUsuario(usuario.data);
			callback();
		}
	} catch (error) {
		logout();
	}
};

export const isAuthenticated = async () => {
	try {
		if (getToken() === null) return false;

		const usuario = await api.get("usuario");

		setUsuario(usuario.data);

		EventsService.triggerEvent(CUSTOM_EVENTS.UPDATE_USER);

		return true;
	} catch (error) {
		logout();

		return false;
	}
};

const getUsuario = () => store.getState().auth.usuario;

export const getUsername = () => getUsuario().nome;
